export default class Control {
	constructor(callback) {
		this.callback = callback;
		this.mob = null;
		this.n = 0;
		this.s = 0;
		this.w = 0;
		this.e = 0;
		this.eventDivider = 2;
		this.check = 0;
		this.lastStatus = { x: -100, y: -100 };
		this.enabled = false;
		this.fired = false;
	}

	init() {
		console.log("to_override")
	}

	enable(lFlag) {
		this.enabled = lFlag;
		if (!lFlag) {
			this.stop();
		}
	}

	stop() {
		this.n = 0;
		this.s = 0;
		this.w = 0;
		this.e = 0;
	}


	dispatch(e) {
		if (this.callback) {
			this.callback.call(null, e);
		}
	}

	attachTo(mob) {
		this.mob = mob;
		mob.controller = this;
	}

	startCheck() {
		this.check++;
		//requestAnimationFrame(this.checkIfDispatch.bind(this));
		this.checkIfDispatch();
	}

	checkIfDispatch() {
		if (this.check % this.eventDivider === 0) {
			this.check = 0;
			let x = this.e + this.w;
			let y = this.n + this.s;

			if ((this.lastStatus.x !== x) || (this.lastStatus.y !== y)) {
				this.lastStatus.x = x;
				this.lastStatus.y = y;
				this.dispatch({ type: Control.EVENT_CHANGED_STATUS, data: { mob: this.mob, status: this.getStatus() } });
			}


			//console.log(x, y)
			if ((x !== 0) || (y !== 0)) {
				let data = {
					x: x * this.mob.getSpeed(),
					y: y * this.mob.getSpeed(),
					mob: this.mob
				}
				//console.log(data);
				

				this.dispatch({ type: Control.EVENT_MOVE, data: data });


			}

			if (this.fired) {
				this.fired = false;
				this.dispatch({ type: Control.EVENT_FIRED, data: { mob: this.mob } });
			}

		}

		//this.startCheck();
	}

	getStatus() {
		let ret;
		let x = this.lastStatus.x;
		let y = this.lastStatus.y;
		if ((x === 0) && (y === 0)) {
			ret = "idle";
		} else if (y < 0) {
			ret = "walk_n";
		} else if (x < 0) {
			ret = "walk_w";
		} else if (x > 0) {
			ret = "walk_e";
		} else if (y > 0) {
			ret = "walk_s";
		}
		return ret;
	}

}
Control.EVENT_MOVE = "eventMove"
Control.EVENT_FIRED = "eventFired"
Control.EVENT_CHANGED_STATUS = "eventChangedStatus";

Control.UP = 87;
Control.DOWN = 83;
Control.LEFT = 65;
Control.RIGHT = 68;
Control.FIRE = 69//32;

Control.SPEED_NORMAL = "speedNormal";
Control.SPEED_FAST = "speedFast";
Control.SPEED_SLOW = "speedSlow";
Control.SPEED_VERY_SLOW = "speedVerySlow";

Control.UP_ALT = 38;
Control.DOWN_ALT = 40;
Control.LEFT_ALT = 37;
Control.RIGHT_ALT = 39;
Control.FIRE_ALT = 32;
